module.exports = __webpack_public_path__ + "e00c8ccec9c55783b151e291bb0914fd.svg";